import { DisneySearchFormSubmitInterface } from '@smartlinks/react-design-system/dist/src/lib/disney/shared/interfaces/disney-search-form.interface';
import { DisneySearchWidgetSkeleton } from '../../templates/common/skeletons/disney-search-widget-skeleton';
import { SearchWidgetInterface } from '../../shared/interfaces/search.interface';
import useSearchWidgetSkeleton from '../../shared/hooks/useSearchWidgetSkeleton';
import DisneySearch from '../../templates/disney-search/disney-search';
import { DisneyService } from '../../shared/services/disney.service';
import useSearchWidget from '../../shared/hooks/useSearchWidget';
import { CommonsUtil } from '../../shared/utils/commons';
import styles from 'bundle-text:./disney-search.scss';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';

export interface DisneySearchWidgetProps extends SearchWidgetInterface<DisneySearchFormSubmitInterface> {
	useMinimunOnePassenger?: boolean;
	isNotHome?: boolean;
}

export const AppDisneySearchWidget = ({
	token,
	language,
	useExternalRedirect,
	agency,
	useMinimunOnePassenger,
	callUrlSearch,
	callShowMobileFields,
	isNotHome,
}: DisneySearchWidgetProps): JSX.Element => {
	const widgetClassName: string = 'disneySearchWidget';
	const {
		agencyState,
		isLoading,
		widgetStyles,
		widgetService: disneyService,
		urlSearchHandler,
		showMobileFieldsHandler,
		t,
	} = useSearchWidget<DisneyService, DisneySearchFormSubmitInterface>({
		token,
		language,
		agency,
		className: widgetClassName,
		styles: styles?.toString() || '',
		callUrlSearch,
		callShowMobileFields,
		productServiceClass: DisneyService,
	});

	const { showSkeleton, isFadingOut } = useSearchWidgetSkeleton(isLoading);
	return (
		<Suspense fallback={<div data-testid='disney-search.widget.loading.fallback'>...</div>}>
			{widgetStyles}
			{showSkeleton && <DisneySearchWidgetSkeleton isFadingOut={isFadingOut} />}
			<div id={agencyState?.profile?.name?.replace(/\s+/g, '') || 'noName'} className={widgetClassName} data-testid='disney-search.widget.container'>
				{!showSkeleton && !isLoading && (
					<DisneySearch
						language={language || 'es'}
						agency={agencyState}
						disneyService={disneyService}
						callUrlSearch={urlSearchHandler}
						t={t}
						useExternalRedirect={useExternalRedirect || false}
						callShowMobileFields={showMobileFieldsHandler}
						useMinimunOnePassenger={useMinimunOnePassenger}
						isNotHome={isNotHome}
					/>
				)}
			</div>
		</Suspense>
	);
};

export function DisneySearchWidget(props: DisneySearchWidgetProps): void {
	const element: HTMLDivElement | null = CommonsUtil.verifyWidgetElement(props?.elementId);
	if (element) {
		void CommonsUtil.createShadowRoot(element, { includeIndexStyles: true, includeFonts: true }).then((renderIn: HTMLDivElement) => {
			const root = createRoot(renderIn);
			root.render(
				<div className='reactWidget disneySearch' data-testid='disney-search.widget.root'>
					<AppDisneySearchWidget {...props} />
				</div>,
			);

			if (props?.callBack) {
				props.callBack(element);
			}
		});
	}
}
